document.addEventListener("DOMContentLoaded", function () {

    // Get cookie by prefix
    function getCookie(namePrefix) {
        let cookies = document.cookie.split('; ');
        for (let cookie of cookies) {
            if (cookie.startsWith(namePrefix)) {
                return decodeURIComponent(cookie.split('=')[1]);
            }
        }
        return null;
    }

    // Check if user has accepted analytics cookie
    function hasAnalyticsConsent(cookieValue) {
        try {
            let parsed = JSON.parse(cookieValue);
            return parsed.consents && 
                   parsed.consents.analytics?.status === 1;
        } catch (e) {
            console.log("Error while parsing cookie:", e);
            return false;
        }
    }

    // Update the value of hidden form field
    function updateFormHiddenField(valueToReplace) {
        document.querySelectorAll("input[type='hidden']").forEach(input => {
            if (input.value === "{PiwikProVisitorId}" || input.hasAttribute("data-piwik-id")) {
                input.value = valueToReplace;
                input.setAttribute("data-piwik-id", "true");  // Add a custom "data-piwik-id" attribute to recognize the updated field
            }
        });
    }

    function handleCookieCheckOnLoad() {
        let privacyValue = getCookie("ppms_privacy");
        let pkIdValue = getCookie("_pk_id");

        if (privacyValue && pkIdValue && hasAnalyticsConsent(privacyValue)) {
            // set visitor id
            updateFormHiddenField(pkIdValue);
        } else {
            let lang = llbPortal.language;
            if (lang === "de") {
                message = "Keine Cookie-Einwilligung erhalten";
            }
            else{
                message = "No cookie consent received";
            }            
            updateFormHiddenField(message);
        }
    }

    // Initial check on page load
    handleCookieCheckOnLoad();

    // Attach interval check for the cookie consent modal window
    // It's important for cases when the cookie banner appears on the page with the form
    // Interval starts if the piwik script exisist on the page (ppms) and if there is a form with "data-piwik-id" attribute 
    if (window.ppms && window.ppms.cm && document.querySelector("input[type='hidden'][data-piwik-id]") !== null) {
        const checkConsent = setInterval(() => {
            if (window.ppms && window.ppms.cm) {
                ppms.cm.api('getComplianceSettings', (settings) => {
                    const analyticsConsent = settings.consents.analytics?.status;    
                    if (analyticsConsent === 1) {
                        let pkIdValue = getCookie("_pk_id");
                        // Update field with "data-piwik-id" attribute
                        updateFormHiddenField(pkIdValue);
                        clearInterval(checkConsent);
                    }
                    else if (analyticsConsent === 0){
                        clearInterval(checkConsent);
                    }
                });
            }
        }, 2000);
    }    
});